"use client";
//#region packages/@mantine/core/src/components/SimpleGrid/SimpleGrid.module.css
var SimpleGrid_module_default = {
	"container": "m_925c2d2c",
	"root": "m_2415a157"
};
//#endregion
export { SimpleGrid_module_default as default };

//# sourceMappingURL=SimpleGrid.module.mjs.map